import { useSelector } from 'react-redux';
import { selectIsBuildersProjectsTabEnabled } from '../../selectors/buildersProjects';
import { BuildersProjectsBanner } from '../../components/BuildersProjectsBanner';
import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { getRandomBoolean } from '../../utils/banners';
import { MortgageBanner } from '../../components/MortgageBanner';

export const BannerContainer: React.FC = () => {
  const showBuildersProjectsBanner = useSelector(selectIsBuildersProjectsTabEnabled);
  const device = useDeviceType();

  if (getRandomBoolean() || device !== 'desktop') {
    return <MortgageBanner />;
  }

  if (showBuildersProjectsBanner && device === 'desktop') {
    return <BuildersProjectsBanner />;
  }

  return null;
};
